import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import FAQ from '../components/FAQ';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <Testimonials />
      <FAQ />
      <CTA />
    </>
  );
};

export default Home;